<template>
  <div class="flex items-center">
    <vs-avatar :src="params.data.img ? `${base}/storage/${params.data.img}` : `${base}/storage/no-image.jpg`" class="flex-shrink-0 mr-2" size="30px" />
  </div>
</template>

<script>
    import themeConfig from "../../../../../themeConfig"
    export default {
        name: 'CellRendererLink',
        computed: {
          base(){
            return themeConfig.API_URL
          }
        }
    }
</script>
